import axios from "axios";

export const fetchCustomers = async () => {
    const response = await axios.get(
        process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1/fetch/users/all",
        {
            params: { userType: "CUSTOMER" },
        }
    );

    return response.data.data || [];
};

export const fetchTechnicians = async () => {
    const res = await axios.get(
        process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1/fetch/users/all?userType=TECHNICIAN"
    );
    return res.data.data;
};
